// extracted by mini-css-extract-plugin
module.exports = {"column":"shapes_column__fCAo0","many":"shapes_many__CawFx","area":"shapes_area__Lmb6W","stack":"shapes_stack__ISxDd","line":"shapes_line__YFfLO"};